import '@backstage/cli/asset-types';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/canon/css/styles.css';


// Set sidebar to unpinned by default
localStorage.setItem('backstage.sidebar.pinned', 'false');



ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
